const STORAGE_KEY = 'homeGender';

function readSavedGender() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'female' || saved === 'male') return saved;
  } catch {
    /* ignore */
  }
  return 'male';
}

function saveGender(gender) {
  try {
    localStorage.setItem(STORAGE_KEY, gender);
  } catch {
    /* ignore */
  }
}

function isFemaleToken(value) {
  return ['female', 'feamale', 'women', 'woman'].includes(value);
}

function isMaleToken(value) {
  return ['male', 'men', 'man'].includes(value);
}

/** Read gender from `?gender=male`, `?male`, `?female`, or `?feamale`. */
export function parseHomeGender(search) {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const named = (params.get('gender') || '').trim().toLowerCase();
  if (isFemaleToken(named)) return 'female';
  if (isMaleToken(named)) return 'male';
  if (params.has('female') || params.has('feamale')) return 'female';
  if (params.has('male')) return 'male';
  return null;
}

export function getSavedHomeGender() {
  return readSavedGender();
}

export function homeGenderPath(gender) {
  return gender === 'female' ? '/?gender=female' : '/?gender=male';
}

export function resolveHomeGender(search) {
  const fromUrl = parseHomeGender(search);
  if (fromUrl) {
    saveGender(fromUrl);
    return fromUrl;
  }
  return readSavedGender();
}

/** If the URL is `/` without a canonical gender query, return the path to redirect to. */
export function canonicalHomeRedirect(search) {
  const fromUrl = parseHomeGender(search);
  if (!fromUrl) {
    return homeGenderPath(readSavedGender());
  }
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const named = (params.get('gender') || '').trim().toLowerCase();
  const alreadyCanonical =
    (named === 'male' || named === 'female') &&
    !params.has('male') &&
    !params.has('female') &&
    !params.has('feamale');
  if (alreadyCanonical) return null;
  return homeGenderPath(fromUrl);
}
